import React from 'react';
import { renderToString } from 'react-dom/server';
import { useSelector, useDispatch } from 'react-redux';

import { Marker } from 'react-leaflet';
import L from 'leaflet';

import Icon from '@mdi/react';
import { mdiMapMarkerRadius } from '@mdi/js';

import {
    relocateMarkerDraftCoords,
    markerDraftMapControlSelector, markerDraftCoordsSelector,
    markerDraftColorSelector
} from '../../../features/places/placesSlice';



const OsmMarkerCreate = () => {
    const dispatch = useDispatch();
    const markerDraftMapControl = useSelector(markerDraftMapControlSelector);
    const markerDraftCoords = useSelector(markerDraftCoordsSelector);
    const markerDraftColor = useSelector(markerDraftColorSelector);

    const relocateVertex = (e) => {
        dispatch(relocateMarkerDraftCoords({
            lat: e.target.getLatLng().lat,
            lng: e.target.getLatLng().lng
        }))
    }

    if (!markerDraftMapControl) {
        return null;
    } else {
        return (
            <div>
                {
                    markerDraftCoords.lat && markerDraftCoords.lng &&
                    <Marker
                        position={markerDraftCoords}
                        draggable={true}
                        eventHandlers={{
                            dragend: (e) => relocateVertex(e),
                        }}
                        icon={L.divIcon({
                            html: renderToString(
                                <Icon
                                    path={mdiMapMarkerRadius}
                                    color={markerDraftColor}
                                    size={1}
                                />
                            ),
                            iconSize: [40, 20],
                            iconAnchor: [20, 10],
                            className: 'dummy',

                        })}
                    />
                }

            </div>
        );
    }
}

export default OsmMarkerCreate;